export function normTxt(value: unknown): string {
  return (value ?? '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
}

export function esPlanFamiliar(plan: string): boolean {
  const p = normTxt(plan);
  return (
    p === 'F' ||
    p === 'FA' ||
    p === 'EMP' ||
    p === 'E' ||
    p.includes('FAMILIAR') ||
    p.includes('EMPLEADO')
  );
}

export function esPlanAsociadoOEmpleado(plan: string): boolean {
  const p = normTxt(plan);
  return (
    p === 'A' ||
    p === 'AS' ||
    p.includes('ASOCIADO')
  );
}

export function resolverCuentaPorTipoPlan(plan: string, cuentaActual: string): string {
  if (esPlanFamiliar(plan)) {
    return '2';
  }

  if (esPlanAsociadoOEmpleado(plan)) {
    return '1';
  }

  return cuentaActual;
}

export function normalizeTipoPlanTarifa(value: unknown): string {
  const plan = normTxt(value);

  if (!plan) return '';
  if (plan === 'AG' || plan === 'GA' || plan.includes('AFINIDAD')) return 'GA';
  if (plan === 'CY' || plan === 'C' || plan.includes('COLECTIV')) return 'C';
  if (plan === 'EMP' || plan === 'E' || plan.includes('EMPLEADO')) return 'E';
  if (plan === 'FA' || plan === 'F' || plan.includes('FAMILIAR')) return 'F';
  if (plan === 'AS' || plan === 'A' || plan.includes('ASOCIADO')) return 'A';

  return plan;
}
